import { useEffect, useState } from "react";
import { TextField, ManualInput } from "../../../../utils/form";
import { useManualInputRows } from "../../../../utils/hooks";
import { useFieldArray } from "react-hook-form";
import { Button, Stack } from "@mui/material";
import _ from "lodash";
import RadioGrup from "../../../../utils/form/RadioGrup";

const options = [
  { label: "Texto", value: "text" },
  { label: "Casillas de verificación", value: "set" },
];

const ContentHelperText = ({ type }) => (
  <span>
    Por ejemplo:{" "}
    {type === "prescription"
      ? "Atenolol 5mg x 28 comprimidos"
      : "RMN cerebro sin contraste"}
  </span>
);

const TextInput = ({ form: { control }, type, checkMargin }) => {
  const rows = useManualInputRows();
  return (
    <ManualInput
      form={{ control }}
      name="content"
      label="Indicaciones"
      helperText={<ContentHelperText type={type} />}
      sx={{ width: "100%", mb: checkMargin }}
      {...rows}
    />
  );
};

const OptionInput = (props) => {
  const {
    form: { control },
    index,
  } = props;
  const label = `Opción ${index + 1}`;
  return <TextField {...props} control={control} label={label} />;
};

const SetInput = ({ form, originalTemplate, checkMargin }) => {
  const { fields, append } = useFieldArray({
    control: form.control,
    name: "contents",
  });
  const { watch } = form;
  const { contents: watchedContents } = watch();

  const addOption = () => append("");

  useEffect(() => {
    if (!_.isEmpty(fields)) return;
    addOption();
  }, [fields]);

  useEffect(() => {
    const content = _.get(originalTemplate, "content", "");
    const contents = content.split(",");
    form.setValue("contents", contents);
  }, []);

  useEffect(() => {
    const options = _(watchedContents).compact().join(",");
    form.setValue("content", options);
  }, [JSON.stringify(watchedContents)]);

  return (
    <>
      <Stack>
        {_(fields)
          .map((field, index) => (
            <Stack key={index} py="1rem" sx={{ mb: checkMargin }}>
              <OptionInput
                form={form}
                name={`contents[${index}]`}
                required={index === 0}
                index={index}
              />
            </Stack>
          ))
          .value()}
      </Stack>
      <Button variant="outlined" onClick={addOption} sx={{ mr: checkMargin }}>
        Agregar opción
      </Button>
    </>
  );
};

const MethodBasedInput = ({ method, type, ...props }) => {
  return method === "text" ? (
    <TextInput {...props} type={type} />
  ) : (
    <SetInput {...props} />
  );
};

const ContentInput = (props) => {
  const { originalTemplate, form, type } = props;
  const defaultMethod = originalTemplate?.inputMethod || "text";
  const [method, setMethod] = useState(defaultMethod);

  useEffect(() => {
    form.resetField("content");
    form.resetField("contents");
    form.setValue("inputMethod", method);
  }, [method]);

  return (
    <>
      <RadioGrup
        method={method}
        handleChange={(event) => setMethod(event.target.value)}
        options={options}
      />
      <MethodBasedInput {...props} method={method} type={type} />
      <input type="hidden" name="inputMethod" />
    </>
  );
};

export default ContentInput;
